import { User, Users, Building2, ArrowUpRight } from "lucide-react";
import { SOLUTIONS, waLink } from "../../data/site";
import { Reveal } from "./Reveal";

const ICONS = { User, Users, Building2 };

export const Solutions = () => (
  <section id="planos" data-testid="solutions-section" className="bg-cream py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.24em] text-champagne-dark">
          Soluções
        </p>
        <h2 className="mt-4 max-w-2xl font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl lg:text-5xl">
          Encontre o plano ideal para você
        </h2>
        <p className="mt-5 max-w-2xl text-base leading-relaxed text-stone-400 sm:text-lg">
          Opções de diferentes operadoras, modalidades, faixas de preço, redes
          credenciadas e regiões — analisadas de acordo com o seu perfil.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-3">
        {SOLUTIONS.map((s, i) => {
          const Icon = ICONS[s.icon];
          return (
            <Reveal key={s.id} delay={i * 0.08}>
              <a
                href={waLink(`Olá! Gostaria de conhecer opções de ${s.title}.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`solution-card-${s.id}`}
                className="group flex h-full flex-col rounded-3xl border border-white/5 bg-surface p-9 transition-[border-color,box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:border-champagne/40 hover:shadow-[0_24px_60px_-24px_rgba(0,0,0,0.6)]"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-champagne-light text-champagne-dark transition-[background-color,color] duration-500 group-hover:bg-brand group-hover:text-white">
                    <Icon className="h-6 w-6" strokeWidth={1.8} />
                  </span>
                  <ArrowUpRight className="h-5 w-5 text-stone-600 transition-[color,transform] duration-500 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-champagne-dark" />
                </div>
                <span className="mt-7 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-stone-500">
                  {s.tag}
                </span>
                <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-ink">
                  {s.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-stone-400">
                  {s.text}
                </p>
                <span className="mt-6 text-sm font-semibold text-champagne-dark opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  Falar com um consultor
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
